export default "__VITE_ASSET__Dxa$nD3y__"